import { jsxs as ze, jsx as F, Fragment as Lr } from "react/jsx-runtime";
import * as wt from "react";
import $t, { forwardRef as _r, cloneElement as Vn, useState as He, useLayoutEffect as Mr, useEffect as Fn, useRef as Br, createContext as Vr, useContext as Fr } from "react";
import { createPortal as Ur } from "react-dom";
var lt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Wr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Hr = typeof lt == "object" && lt && lt.Object === Object && lt, Un = Hr, qr = Un, Gr = typeof self == "object" && self && self.Object === Object && self, Yr = qr || Gr || Function("return this")(), zr = Yr, Xr = zr, Tr = Xr.Symbol, Ut = Tr;
function Kr(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var Jr = Kr, Zr = Array.isArray, Qr = Zr, Jt = Ut, Wn = Object.prototype, Nr = Wn.hasOwnProperty, Pr = Wn.toString, Ue = Jt ? Jt.toStringTag : void 0;
function Ir(e) {
  var t = Nr.call(e, Ue), n = e[Ue];
  try {
    e[Ue] = void 0;
    var r = !0;
  } catch {
  }
  var i = Pr.call(e);
  return r && (t ? e[Ue] = n : delete e[Ue]), i;
}
var ei = Ir, ti = Object.prototype, ni = ti.toString;
function ri(e) {
  return ni.call(e);
}
var ii = ri, Zt = Ut, oi = ei, ai = ii, si = "[object Null]", ci = "[object Undefined]", Qt = Zt ? Zt.toStringTag : void 0;
function li(e) {
  return e == null ? e === void 0 ? ci : si : Qt && Qt in Object(e) ? oi(e) : ai(e);
}
var Wt = li;
function ui(e) {
  return e != null && typeof e == "object";
}
var Hn = ui, fi = Wt, pi = Hn, di = "[object Symbol]";
function vi(e) {
  return typeof e == "symbol" || pi(e) && fi(e) == di;
}
var gi = vi, Nt = Ut, bi = Jr, mi = Qr, yi = gi, hi = 1 / 0, Pt = Nt ? Nt.prototype : void 0, It = Pt ? Pt.toString : void 0;
function qn(e) {
  if (typeof e == "string")
    return e;
  if (mi(e))
    return bi(e, qn) + "";
  if (yi(e))
    return It ? It.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -hi ? "-0" : t;
}
var Gn = qn;
function wi(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var a = Array(i); ++r < i; )
    a[r] = e[r + t];
  return a;
}
var xi = wi, Oi = xi;
function Ei(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : Oi(e, t, n);
}
var Ai = Ei, ki = "\\ud800-\\udfff", Si = "\\u0300-\\u036f", Di = "\\ufe20-\\ufe2f", $i = "\\u20d0-\\u20ff", ji = Si + Di + $i, Ci = "\\ufe0e\\ufe0f", Ri = "\\u200d", Li = RegExp("[" + Ri + ki + ji + Ci + "]");
function _i(e) {
  return Li.test(e);
}
var Yn = _i;
function Mi(e, t) {
  return e === t || e !== e && t !== t;
}
var Bi = Mi;
function Vi(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var zn = Vi, Fi = Wt, Ui = zn, Wi = "[object AsyncFunction]", Hi = "[object Function]", qi = "[object GeneratorFunction]", Gi = "[object Proxy]";
function Yi(e) {
  if (!Ui(e))
    return !1;
  var t = Fi(e);
  return t == Hi || t == qi || t == Wi || t == Gi;
}
var zi = Yi, Xi = 9007199254740991;
function Ti(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Xi;
}
var Ki = Ti, Ji = zi, Zi = Ki;
function Qi(e) {
  return e != null && Zi(e.length) && !Ji(e);
}
var Ni = Qi, Pi = 9007199254740991, Ii = /^(?:0|[1-9]\d*)$/;
function eo(e, t) {
  var n = typeof e;
  return t = t ?? Pi, !!t && (n == "number" || n != "symbol" && Ii.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var to = eo, no = Bi, ro = Ni, io = to, oo = zn;
function ao(e, t, n) {
  if (!oo(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? ro(n) && io(t, n.length) : r == "string" && t in n) ? no(n[t], e) : !1;
}
var so = ao, co = Wt, lo = Hn, uo = "[object RegExp]";
function fo(e) {
  return lo(e) && co(e) == uo;
}
var po = fo;
function vo(e) {
  return function(t) {
    return e(t);
  };
}
var go = vo, dt = { exports: {} };
dt.exports;
(function(e, t) {
  var n = Un, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, a = i && i.exports === r, s = a && n.process, l = function() {
    try {
      var c = i && i.require && i.require("util").types;
      return c || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = l;
})(dt, dt.exports);
var bo = dt.exports, mo = po, yo = go, en = bo, tn = en && en.isRegExp, ho = tn ? yo(tn) : mo, wo = ho;
function xo(e) {
  return e.split("");
}
var Oo = xo, Xn = "\\ud800-\\udfff", Eo = "\\u0300-\\u036f", Ao = "\\ufe20-\\ufe2f", ko = "\\u20d0-\\u20ff", So = Eo + Ao + ko, Do = "\\ufe0e\\ufe0f", $o = "[" + Xn + "]", jt = "[" + So + "]", Ct = "\\ud83c[\\udffb-\\udfff]", jo = "(?:" + jt + "|" + Ct + ")", Tn = "[^" + Xn + "]", Kn = "(?:\\ud83c[\\udde6-\\uddff]){2}", Jn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Co = "\\u200d", Zn = jo + "?", Qn = "[" + Do + "]?", Ro = "(?:" + Co + "(?:" + [Tn, Kn, Jn].join("|") + ")" + Qn + Zn + ")*", Lo = Qn + Zn + Ro, _o = "(?:" + [Tn + jt + "?", jt, Kn, Jn, $o].join("|") + ")", Mo = RegExp(Ct + "(?=" + Ct + ")|" + _o + Lo, "g");
function Bo(e) {
  return e.match(Mo) || [];
}
var Vo = Bo, Fo = Oo, Uo = Yn, Wo = Vo;
function Ho(e) {
  return Uo(e) ? Wo(e) : Fo(e);
}
var qo = Ho, Go = Gn;
function Yo(e) {
  return e == null ? "" : Go(e);
}
var zo = Yo, Xo = Gn, To = Ai, Ko = Yn, Jo = so, Zo = wo, Qo = qo, No = zo, Po = 4294967295;
function Io(e, t, n) {
  return n && typeof n != "number" && Jo(e, t, n) && (t = n = void 0), n = n === void 0 ? Po : n >>> 0, n ? (e = No(e), e && (typeof t == "string" || t != null && !Zo(t)) && (t = Xo(t), !t && Ko(e)) ? To(Qo(e), 0, n) : e.split(t, n)) : [];
}
var ea = Io;
const ta = /* @__PURE__ */ Wr(ea);
function Nn(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++)
        e[t] && (n = Nn(e[t])) && (r && (r += " "), r += n);
    } else
      for (n in e)
        e[n] && (r && (r += " "), r += n);
  return r;
}
function na() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++)
    (e = arguments[n]) && (t = Nn(e)) && (r && (r += " "), r += t);
  return r;
}
function Q(...e) {
  return na(e);
}
const nn = "#e9ebed", rn = "#4d565f", ra = "#32e6e2", on = "#04a29f", ia = "#016968", oa = "#64d87f", aa = "#31a855", sa = "#fbb13d", ca = "#d5771a", la = "#fe8382", ua = "#d62740", fa = "#f3a8ee", pa = "#df5adc", da = "#b49df1", va = "#775ce7", ga = "#9cbef6", an = "#5d8df5", ba = "#2e51ed", ma = "8px", ya = {
  to: nn,
  from: nn
}, Mc = {
  to: rn,
  from: rn
}, xt = [
  { to: ba, from: an },
  { to: pa, from: fa },
  { to: va, from: da },
  { to: aa, from: oa },
  { to: ua, from: la },
  { to: on, from: ra },
  { to: ca, from: sa },
  { to: an, from: ga },
  { to: ia, from: on }
], ha = (e = "") => {
  if (!e || typeof e != "string")
    return xt[0];
  const t = e.split("").map((i) => Number(i)).reverse(), n = xt.length - 1, r = t.find(
    (i) => !isNaN(i) && i <= n
  ) ?? 0;
  return xt[r];
}, wa = "https://d33wubrfki0l68.cloudfront.net/", sn = "https://screenshot-proxy.netlify.app/", cn = "/.netlify/images", xa = ({
  animated: e,
  cover: t,
  fit: n,
  format: r,
  height: i,
  scale: a = 2,
  width: s
}) => {
  const l = [`f_${r}`];
  return (t || n === "cover") && i ? (l.push("fit_cover"), l.push(
    `s_${Math.round(s * a)}x${Math.round(i * a)}`
  )) : l.push(`w_${Math.round(s * a)}`), e && l.push("animated"), l.join(",");
}, Oa = ({
  fit: e,
  height: t,
  position: n,
  quality: r,
  scale: i = 2,
  width: a,
  url: s
}) => [
  `url=${encodeURI(s)}`,
  e && `fit=${e}`,
  t && `h=${t * i}`,
  n && `position=${n}`,
  r && `q=${r}`,
  a && `w=${a * i}`
].filter(Boolean).join("&"), Pn = (e = "") => typeof e != "string" || e.startsWith("/") || e.startsWith(wa), In = (e = "", t) => {
  if (typeof e != "string" || e.startsWith(sn) || e.startsWith(cn))
    return e;
  if (Pn(e)) {
    const n = t.cover ? "cover" : void 0;
    return `${cn}?${Oa({ url: e, fit: n, ...t })}`;
  }
  return `${sn}${xa(t)}/${encodeURI(e)}`;
}, Ea = ({
  formats: e,
  url: t,
  options: n
}) => Pn(t) ? [] : e.map((r) => ({
  srcSet: In(t, { ...n, format: r }),
  type: `image/${r}`
})), Aa = ({
  alt: e,
  url: t,
  width: n,
  height: r,
  formats: i = ["avif", "webp"],
  fallbackFormat: a,
  className: s,
  onError: l,
  animated: c = !1,
  cover: p = !1,
  title: f
}) => {
  const y = { width: n, height: r, cover: p, animated: c }, b = Ea({
    // IPX proxy add experimental support for animated webp
    formats: c ? ["webp"] : i,
    url: t,
    options: y
  }), g = In(t, {
    ...y,
    format: a || c ? "gif" : "png"
  });
  return /* @__PURE__ */ ze("picture", { onError: l, className: s, children: [
    b.map((w, m) => /* @__PURE__ */ F("source", { ...w }, `source:${m}`)),
    /* @__PURE__ */ F(
      "img",
      {
        src: g,
        alt: e,
        width: n,
        height: r,
        loading: "lazy",
        className: Q("tw-align-top", p && "tw-h-full tw-w-full"),
        title: f
      }
    )
  ] });
};
var z = "top", N = "bottom", P = "right", X = "left", bt = "auto", Ze = [z, N, P, X], je = "start", Xe = "end", ka = "clippingParents", er = "viewport", We = "popper", Sa = "reference", ln = /* @__PURE__ */ Ze.reduce(function(e, t) {
  return e.concat([t + "-" + je, t + "-" + Xe]);
}, []), tr = /* @__PURE__ */ [].concat(Ze, [bt]).reduce(function(e, t) {
  return e.concat([t, t + "-" + je, t + "-" + Xe]);
}, []), Da = "beforeRead", $a = "read", ja = "afterRead", Ca = "beforeMain", Ra = "main", La = "afterMain", _a = "beforeWrite", Ma = "write", Ba = "afterWrite", Rt = [Da, $a, ja, Ca, Ra, La, _a, Ma, Ba];
function ie(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function J(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function xe(e) {
  var t = J(e).Element;
  return e instanceof t || e instanceof Element;
}
function K(e) {
  var t = J(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Ht(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = J(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function Va(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, a = t.elements[n];
    !K(a) || !ie(a) || (Object.assign(a.style, r), Object.keys(i).forEach(function(s) {
      var l = i[s];
      l === !1 ? a.removeAttribute(s) : a.setAttribute(s, l === !0 ? "" : l);
    }));
  });
}
function Fa(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], a = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), l = s.reduce(function(c, p) {
        return c[p] = "", c;
      }, {});
      !K(i) || !ie(i) || (Object.assign(i.style, l), Object.keys(a).forEach(function(c) {
        i.removeAttribute(c);
      }));
    });
  };
}
const nr = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: Va,
  effect: Fa,
  requires: ["computeStyles"]
};
function ee(e) {
  return e.split("-")[0];
}
var we = Math.max, vt = Math.min, Ce = Math.round;
function Lt() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function rr() {
  return !/^((?!chrome|android).)*safari/i.test(Lt());
}
function Re(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, a = 1;
  t && K(e) && (i = e.offsetWidth > 0 && Ce(r.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && Ce(r.height) / e.offsetHeight || 1);
  var s = xe(e) ? J(e) : window, l = s.visualViewport, c = !rr() && n, p = (r.left + (c && l ? l.offsetLeft : 0)) / i, f = (r.top + (c && l ? l.offsetTop : 0)) / a, y = r.width / i, b = r.height / a;
  return {
    width: y,
    height: b,
    top: f,
    right: p + y,
    bottom: f + b,
    left: p,
    x: p,
    y: f
  };
}
function qt(e) {
  var t = Re(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function ir(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Ht(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function te(e) {
  return J(e).getComputedStyle(e);
}
function Ua(e) {
  return ["table", "td", "th"].indexOf(ie(e)) >= 0;
}
function de(e) {
  return ((xe(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function mt(e) {
  return ie(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Ht(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    de(e)
  );
}
function un(e) {
  return !K(e) || // https://github.com/popperjs/popper-core/issues/837
  te(e).position === "fixed" ? null : e.offsetParent;
}
function Wa(e) {
  var t = /firefox/i.test(Lt()), n = /Trident/i.test(Lt());
  if (n && K(e)) {
    var r = te(e);
    if (r.position === "fixed")
      return null;
  }
  var i = mt(e);
  for (Ht(i) && (i = i.host); K(i) && ["html", "body"].indexOf(ie(i)) < 0; ) {
    var a = te(i);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Qe(e) {
  for (var t = J(e), n = un(e); n && Ua(n) && te(n).position === "static"; )
    n = un(n);
  return n && (ie(n) === "html" || ie(n) === "body" && te(n).position === "static") ? t : n || Wa(e) || t;
}
function Gt(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function qe(e, t, n) {
  return we(e, vt(t, n));
}
function Ha(e, t, n) {
  var r = qe(e, t, n);
  return r > n ? n : r;
}
function or() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function ar(e) {
  return Object.assign({}, or(), e);
}
function sr(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var qa = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, ar(typeof t != "number" ? t : sr(t, Ze));
};
function Ga(e) {
  var t, n = e.state, r = e.name, i = e.options, a = n.elements.arrow, s = n.modifiersData.popperOffsets, l = ee(n.placement), c = Gt(l), p = [X, P].indexOf(l) >= 0, f = p ? "height" : "width";
  if (!(!a || !s)) {
    var y = qa(i.padding, n), b = qt(a), g = c === "y" ? z : X, w = c === "y" ? N : P, m = n.rects.reference[f] + n.rects.reference[c] - s[c] - n.rects.popper[f], x = s[c] - n.rects.reference[c], A = Qe(a), k = A ? c === "y" ? A.clientHeight || 0 : A.clientWidth || 0 : 0, j = m / 2 - x / 2, o = y[g], O = k - b[f] - y[w], d = k / 2 - b[f] / 2 + j, C = qe(o, d, O), L = c;
    n.modifiersData[r] = (t = {}, t[L] = C, t.centerOffset = C - d, t);
  }
}
function Ya(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  if (i != null && !(typeof i == "string" && (i = t.elements.popper.querySelector(i), !i))) {
    if (process.env.NODE_ENV !== "production" && (K(i) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !ir(t.elements.popper, i)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    t.elements.arrow = i;
  }
}
const za = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Ga,
  effect: Ya,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Le(e) {
  return e.split("-")[1];
}
var Xa = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Ta(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: Ce(n * i) / i || 0,
    y: Ce(r * i) / i || 0
  };
}
function fn(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, a = e.variation, s = e.offsets, l = e.position, c = e.gpuAcceleration, p = e.adaptive, f = e.roundOffsets, y = e.isFixed, b = s.x, g = b === void 0 ? 0 : b, w = s.y, m = w === void 0 ? 0 : w, x = typeof f == "function" ? f({
    x: g,
    y: m
  }) : {
    x: g,
    y: m
  };
  g = x.x, m = x.y;
  var A = s.hasOwnProperty("x"), k = s.hasOwnProperty("y"), j = X, o = z, O = window;
  if (p) {
    var d = Qe(n), C = "clientHeight", L = "clientWidth";
    if (d === J(n) && (d = de(n), te(d).position !== "static" && l === "absolute" && (C = "scrollHeight", L = "scrollWidth")), d = d, i === z || (i === X || i === P) && a === Xe) {
      o = N;
      var D = y && d === O && O.visualViewport ? O.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        d[C]
      );
      m -= D - r.height, m *= c ? 1 : -1;
    }
    if (i === X || (i === z || i === N) && a === Xe) {
      j = P;
      var R = y && d === O && O.visualViewport ? O.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        d[L]
      );
      g -= R - r.width, g *= c ? 1 : -1;
    }
  }
  var S = Object.assign({
    position: l
  }, p && Xa), _ = f === !0 ? Ta({
    x: g,
    y: m
  }, J(n)) : {
    x: g,
    y: m
  };
  if (g = _.x, m = _.y, c) {
    var V;
    return Object.assign({}, S, (V = {}, V[o] = k ? "0" : "", V[j] = A ? "0" : "", V.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + m + "px)" : "translate3d(" + g + "px, " + m + "px, 0)", V));
  }
  return Object.assign({}, S, (t = {}, t[o] = k ? m + "px" : "", t[j] = A ? g + "px" : "", t.transform = "", t));
}
function Ka(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, a = n.adaptive, s = a === void 0 ? !0 : a, l = n.roundOffsets, c = l === void 0 ? !0 : l;
  if (process.env.NODE_ENV !== "production") {
    var p = te(t.elements.popper).transitionProperty || "";
    s && ["transform", "top", "right", "bottom", "left"].some(function(y) {
      return p.indexOf(y) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var f = {
    placement: ee(t.placement),
    variation: Le(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, fn(Object.assign({}, f, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: c
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, fn(Object.assign({}, f, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: c
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const Ja = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Ka,
  data: {}
};
var ut = {
  passive: !0
};
function Za(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, a = i === void 0 ? !0 : i, s = r.resize, l = s === void 0 ? !0 : s, c = J(t.elements.popper), p = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && p.forEach(function(f) {
    f.addEventListener("scroll", n.update, ut);
  }), l && c.addEventListener("resize", n.update, ut), function() {
    a && p.forEach(function(f) {
      f.removeEventListener("scroll", n.update, ut);
    }), l && c.removeEventListener("resize", n.update, ut);
  };
}
const Qa = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Za,
  data: {}
};
var Na = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function pt(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return Na[t];
  });
}
var Pa = {
  start: "end",
  end: "start"
};
function pn(e) {
  return e.replace(/start|end/g, function(t) {
    return Pa[t];
  });
}
function Yt(e) {
  var t = J(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function zt(e) {
  return Re(de(e)).left + Yt(e).scrollLeft;
}
function Ia(e, t) {
  var n = J(e), r = de(e), i = n.visualViewport, a = r.clientWidth, s = r.clientHeight, l = 0, c = 0;
  if (i) {
    a = i.width, s = i.height;
    var p = rr();
    (p || !p && t === "fixed") && (l = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: l + zt(e),
    y: c
  };
}
function es(e) {
  var t, n = de(e), r = Yt(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, a = we(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = we(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), l = -r.scrollLeft + zt(e), c = -r.scrollTop;
  return te(i || n).direction === "rtl" && (l += we(n.clientWidth, i ? i.clientWidth : 0) - a), {
    width: a,
    height: s,
    x: l,
    y: c
  };
}
function Xt(e) {
  var t = te(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function cr(e) {
  return ["html", "body", "#document"].indexOf(ie(e)) >= 0 ? e.ownerDocument.body : K(e) && Xt(e) ? e : cr(mt(e));
}
function Ge(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = cr(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), a = J(r), s = i ? [a].concat(a.visualViewport || [], Xt(r) ? r : []) : r, l = t.concat(s);
  return i ? l : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    l.concat(Ge(mt(s)))
  );
}
function _t(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function ts(e, t) {
  var n = Re(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function dn(e, t, n) {
  return t === er ? _t(Ia(e, n)) : xe(t) ? ts(t, n) : _t(es(de(e)));
}
function ns(e) {
  var t = Ge(mt(e)), n = ["absolute", "fixed"].indexOf(te(e).position) >= 0, r = n && K(e) ? Qe(e) : e;
  return xe(r) ? t.filter(function(i) {
    return xe(i) && ir(i, r) && ie(i) !== "body";
  }) : [];
}
function rs(e, t, n, r) {
  var i = t === "clippingParents" ? ns(e) : [].concat(t), a = [].concat(i, [n]), s = a[0], l = a.reduce(function(c, p) {
    var f = dn(e, p, r);
    return c.top = we(f.top, c.top), c.right = vt(f.right, c.right), c.bottom = vt(f.bottom, c.bottom), c.left = we(f.left, c.left), c;
  }, dn(e, s, r));
  return l.width = l.right - l.left, l.height = l.bottom - l.top, l.x = l.left, l.y = l.top, l;
}
function lr(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? ee(r) : null, a = r ? Le(r) : null, s = t.x + t.width / 2 - n.width / 2, l = t.y + t.height / 2 - n.height / 2, c;
  switch (i) {
    case z:
      c = {
        x: s,
        y: t.y - n.height
      };
      break;
    case N:
      c = {
        x: s,
        y: t.y + t.height
      };
      break;
    case P:
      c = {
        x: t.x + t.width,
        y: l
      };
      break;
    case X:
      c = {
        x: t.x - n.width,
        y: l
      };
      break;
    default:
      c = {
        x: t.x,
        y: t.y
      };
  }
  var p = i ? Gt(i) : null;
  if (p != null) {
    var f = p === "y" ? "height" : "width";
    switch (a) {
      case je:
        c[p] = c[p] - (t[f] / 2 - n[f] / 2);
        break;
      case Xe:
        c[p] = c[p] + (t[f] / 2 - n[f] / 2);
        break;
    }
  }
  return c;
}
function Te(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, a = n.strategy, s = a === void 0 ? e.strategy : a, l = n.boundary, c = l === void 0 ? ka : l, p = n.rootBoundary, f = p === void 0 ? er : p, y = n.elementContext, b = y === void 0 ? We : y, g = n.altBoundary, w = g === void 0 ? !1 : g, m = n.padding, x = m === void 0 ? 0 : m, A = ar(typeof x != "number" ? x : sr(x, Ze)), k = b === We ? Sa : We, j = e.rects.popper, o = e.elements[w ? k : b], O = rs(xe(o) ? o : o.contextElement || de(e.elements.popper), c, f, s), d = Re(e.elements.reference), C = lr({
    reference: d,
    element: j,
    strategy: "absolute",
    placement: i
  }), L = _t(Object.assign({}, j, C)), D = b === We ? L : d, R = {
    top: O.top - D.top + A.top,
    bottom: D.bottom - O.bottom + A.bottom,
    left: O.left - D.left + A.left,
    right: D.right - O.right + A.right
  }, S = e.modifiersData.offset;
  if (b === We && S) {
    var _ = S[i];
    Object.keys(R).forEach(function(V) {
      var B = [P, N].indexOf(V) >= 0 ? 1 : -1, E = [z, N].indexOf(V) >= 0 ? "y" : "x";
      R[V] += _[E] * B;
    });
  }
  return R;
}
function is(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, a = n.rootBoundary, s = n.padding, l = n.flipVariations, c = n.allowedAutoPlacements, p = c === void 0 ? tr : c, f = Le(r), y = f ? l ? ln : ln.filter(function(w) {
    return Le(w) === f;
  }) : Ze, b = y.filter(function(w) {
    return p.indexOf(w) >= 0;
  });
  b.length === 0 && (b = y, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var g = b.reduce(function(w, m) {
    return w[m] = Te(e, {
      placement: m,
      boundary: i,
      rootBoundary: a,
      padding: s
    })[ee(m)], w;
  }, {});
  return Object.keys(g).sort(function(w, m) {
    return g[w] - g[m];
  });
}
function os(e) {
  if (ee(e) === bt)
    return [];
  var t = pt(e);
  return [pn(e), t, pn(t)];
}
function as(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, a = i === void 0 ? !0 : i, s = n.altAxis, l = s === void 0 ? !0 : s, c = n.fallbackPlacements, p = n.padding, f = n.boundary, y = n.rootBoundary, b = n.altBoundary, g = n.flipVariations, w = g === void 0 ? !0 : g, m = n.allowedAutoPlacements, x = t.options.placement, A = ee(x), k = A === x, j = c || (k || !w ? [pt(x)] : os(x)), o = [x].concat(j).reduce(function(oe, I) {
      return oe.concat(ee(I) === bt ? is(t, {
        placement: I,
        boundary: f,
        rootBoundary: y,
        padding: p,
        flipVariations: w,
        allowedAutoPlacements: m
      }) : I);
    }, []), O = t.rects.reference, d = t.rects.popper, C = /* @__PURE__ */ new Map(), L = !0, D = o[0], R = 0; R < o.length; R++) {
      var S = o[R], _ = ee(S), V = Le(S) === je, B = [z, N].indexOf(_) >= 0, E = B ? "width" : "height", H = Te(t, {
        placement: S,
        boundary: f,
        rootBoundary: y,
        altBoundary: b,
        padding: p
      }), W = B ? V ? P : X : V ? N : z;
      O[E] > d[E] && (W = pt(W));
      var U = pt(W), G = [];
      if (a && G.push(H[_] <= 0), l && G.push(H[W] <= 0, H[U] <= 0), G.every(function(oe) {
        return oe;
      })) {
        D = S, L = !1;
        break;
      }
      C.set(S, G);
    }
    if (L)
      for (var q = w ? 3 : 1, ve = function(I) {
        var ae = o.find(function(Oe) {
          var se = C.get(Oe);
          if (se)
            return se.slice(0, I).every(function(Ee) {
              return Ee;
            });
        });
        if (ae)
          return D = ae, "break";
      }, ne = q; ne > 0; ne--) {
        var ge = ve(ne);
        if (ge === "break")
          break;
      }
    t.placement !== D && (t.modifiersData[r]._skip = !0, t.placement = D, t.reset = !0);
  }
}
const ss = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: as,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function vn(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function gn(e) {
  return [z, P, N, X].some(function(t) {
    return e[t] >= 0;
  });
}
function cs(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, a = t.modifiersData.preventOverflow, s = Te(t, {
    elementContext: "reference"
  }), l = Te(t, {
    altBoundary: !0
  }), c = vn(s, r), p = vn(l, i, a), f = gn(c), y = gn(p);
  t.modifiersData[n] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: p,
    isReferenceHidden: f,
    hasPopperEscaped: y
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": f,
    "data-popper-escaped": y
  });
}
const ls = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: cs
};
function us(e, t, n) {
  var r = ee(e), i = [X, z].indexOf(r) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = a[0], l = a[1];
  return s = s || 0, l = (l || 0) * i, [X, P].indexOf(r) >= 0 ? {
    x: l,
    y: s
  } : {
    x: s,
    y: l
  };
}
function fs(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, a = i === void 0 ? [0, 0] : i, s = tr.reduce(function(f, y) {
    return f[y] = us(y, t.rects, a), f;
  }, {}), l = s[t.placement], c = l.x, p = l.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += c, t.modifiersData.popperOffsets.y += p), t.modifiersData[r] = s;
}
const ps = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: fs
};
function ds(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = lr({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const vs = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ds,
  data: {}
};
function gs(e) {
  return e === "x" ? "y" : "x";
}
function bs(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, a = i === void 0 ? !0 : i, s = n.altAxis, l = s === void 0 ? !1 : s, c = n.boundary, p = n.rootBoundary, f = n.altBoundary, y = n.padding, b = n.tether, g = b === void 0 ? !0 : b, w = n.tetherOffset, m = w === void 0 ? 0 : w, x = Te(t, {
    boundary: c,
    rootBoundary: p,
    padding: y,
    altBoundary: f
  }), A = ee(t.placement), k = Le(t.placement), j = !k, o = Gt(A), O = gs(o), d = t.modifiersData.popperOffsets, C = t.rects.reference, L = t.rects.popper, D = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, R = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), S = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, _ = {
    x: 0,
    y: 0
  };
  if (d) {
    if (a) {
      var V, B = o === "y" ? z : X, E = o === "y" ? N : P, H = o === "y" ? "height" : "width", W = d[o], U = W + x[B], G = W - x[E], q = g ? -L[H] / 2 : 0, ve = k === je ? C[H] : L[H], ne = k === je ? -L[H] : -C[H], ge = t.elements.arrow, oe = g && ge ? qt(ge) : {
        width: 0,
        height: 0
      }, I = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : or(), ae = I[B], Oe = I[E], se = qe(0, C[H], oe[H]), Ee = j ? C[H] / 2 - q - se - ae - R.mainAxis : ve - se - ae - R.mainAxis, ue = j ? -C[H] / 2 + q + se + Oe + R.mainAxis : ne + se + Oe + R.mainAxis, Ae = t.elements.arrow && Qe(t.elements.arrow), Pe = Ae ? o === "y" ? Ae.clientTop || 0 : Ae.clientLeft || 0 : 0, _e = (V = S == null ? void 0 : S[o]) != null ? V : 0, Ie = W + Ee - _e - Pe, et = W + ue - _e, Me = qe(g ? vt(U, Ie) : U, W, g ? we(G, et) : G);
      d[o] = Me, _[o] = Me - W;
    }
    if (l) {
      var Be, tt = o === "x" ? z : X, nt = o === "x" ? N : P, ce = d[O], fe = O === "y" ? "height" : "width", Ve = ce + x[tt], be = ce - x[nt], Fe = [z, X].indexOf(A) !== -1, rt = (Be = S == null ? void 0 : S[O]) != null ? Be : 0, it = Fe ? Ve : ce - C[fe] - L[fe] - rt + R.altAxis, ot = Fe ? ce + C[fe] + L[fe] - rt - R.altAxis : be, at = g && Fe ? Ha(it, ce, ot) : qe(g ? it : Ve, ce, g ? ot : be);
      d[O] = at, _[O] = at - ce;
    }
    t.modifiersData[r] = _;
  }
}
const ms = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: bs,
  requiresIfExists: ["offset"]
};
function ys(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function hs(e) {
  return e === J(e) || !K(e) ? Yt(e) : ys(e);
}
function ws(e) {
  var t = e.getBoundingClientRect(), n = Ce(t.width) / e.offsetWidth || 1, r = Ce(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function xs(e, t, n) {
  n === void 0 && (n = !1);
  var r = K(t), i = K(t) && ws(t), a = de(t), s = Re(e, i, n), l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((ie(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Xt(a)) && (l = hs(t)), K(t) ? (c = Re(t, !0), c.x += t.clientLeft, c.y += t.clientTop) : a && (c.x = zt(a))), {
    x: s.left + l.scrollLeft - c.x,
    y: s.top + l.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function Os(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function i(a) {
    n.add(a.name);
    var s = [].concat(a.requires || [], a.requiresIfExists || []);
    s.forEach(function(l) {
      if (!n.has(l)) {
        var c = t.get(l);
        c && i(c);
      }
    }), r.push(a);
  }
  return e.forEach(function(a) {
    n.has(a.name) || i(a);
  }), r;
}
function Es(e) {
  var t = Os(e);
  return Rt.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function As(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function pe(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return [].concat(n).reduce(function(i, a) {
    return i.replace(/%s/, a);
  }, e);
}
var ye = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', ks = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', bn = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function Ss(e) {
  e.forEach(function(t) {
    [].concat(Object.keys(t), bn).filter(function(n, r, i) {
      return i.indexOf(n) === r;
    }).forEach(function(n) {
      switch (n) {
        case "name":
          typeof t.name != "string" && console.error(pe(ye, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(pe(ye, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
          break;
        case "phase":
          Rt.indexOf(t.phase) < 0 && console.error(pe(ye, t.name, '"phase"', "either " + Rt.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(pe(ye, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          t.effect != null && typeof t.effect != "function" && console.error(pe(ye, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          t.requires != null && !Array.isArray(t.requires) && console.error(pe(ye, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(pe(ye, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + bn.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + n + '" was provided.');
      }
      t.requires && t.requires.forEach(function(r) {
        e.find(function(i) {
          return i.name === r;
        }) == null && console.error(pe(ks, String(t.name), r, r));
      });
    });
  });
}
function Ds(e, t) {
  var n = /* @__PURE__ */ new Set();
  return e.filter(function(r) {
    var i = t(r);
    if (!n.has(i))
      return n.add(i), !0;
  });
}
function $s(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var mn = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", js = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", yn = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function hn() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function Cs(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, a = i === void 0 ? yn : i;
  return function(l, c, p) {
    p === void 0 && (p = a);
    var f = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, yn, a),
      modifiersData: {},
      elements: {
        reference: l,
        popper: c
      },
      attributes: {},
      styles: {}
    }, y = [], b = !1, g = {
      state: f,
      setOptions: function(A) {
        var k = typeof A == "function" ? A(f.options) : A;
        m(), f.options = Object.assign({}, a, f.options, k), f.scrollParents = {
          reference: xe(l) ? Ge(l) : l.contextElement ? Ge(l.contextElement) : [],
          popper: Ge(c)
        };
        var j = Es($s([].concat(r, f.options.modifiers)));
        if (f.orderedModifiers = j.filter(function(S) {
          return S.enabled;
        }), process.env.NODE_ENV !== "production") {
          var o = Ds([].concat(j, f.options.modifiers), function(S) {
            var _ = S.name;
            return _;
          });
          if (Ss(o), ee(f.options.placement) === bt) {
            var O = f.orderedModifiers.find(function(S) {
              var _ = S.name;
              return _ === "flip";
            });
            O || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var d = te(c), C = d.marginTop, L = d.marginRight, D = d.marginBottom, R = d.marginLeft;
          [C, L, D, R].some(function(S) {
            return parseFloat(S);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return w(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!b) {
          var A = f.elements, k = A.reference, j = A.popper;
          if (!hn(k, j)) {
            process.env.NODE_ENV !== "production" && console.error(mn);
            return;
          }
          f.rects = {
            reference: xs(k, Qe(j), f.options.strategy === "fixed"),
            popper: qt(j)
          }, f.reset = !1, f.placement = f.options.placement, f.orderedModifiers.forEach(function(S) {
            return f.modifiersData[S.name] = Object.assign({}, S.data);
          });
          for (var o = 0, O = 0; O < f.orderedModifiers.length; O++) {
            if (process.env.NODE_ENV !== "production" && (o += 1, o > 100)) {
              console.error(js);
              break;
            }
            if (f.reset === !0) {
              f.reset = !1, O = -1;
              continue;
            }
            var d = f.orderedModifiers[O], C = d.fn, L = d.options, D = L === void 0 ? {} : L, R = d.name;
            typeof C == "function" && (f = C({
              state: f,
              options: D,
              name: R,
              instance: g
            }) || f);
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: As(function() {
        return new Promise(function(x) {
          g.forceUpdate(), x(f);
        });
      }),
      destroy: function() {
        m(), b = !0;
      }
    };
    if (!hn(l, c))
      return process.env.NODE_ENV !== "production" && console.error(mn), g;
    g.setOptions(p).then(function(x) {
      !b && p.onFirstUpdate && p.onFirstUpdate(x);
    });
    function w() {
      f.orderedModifiers.forEach(function(x) {
        var A = x.name, k = x.options, j = k === void 0 ? {} : k, o = x.effect;
        if (typeof o == "function") {
          var O = o({
            state: f,
            name: A,
            instance: g,
            options: j
          }), d = function() {
          };
          y.push(O || d);
        }
      });
    }
    function m() {
      y.forEach(function(x) {
        return x();
      }), y = [];
    }
    return g;
  };
}
var Rs = [Qa, vs, Ja, nr, ps, ss, ms, za, ls], Ls = /* @__PURE__ */ Cs({
  defaultModifiers: Rs
}), _s = "tippy-box", ur = "tippy-content", Ms = "tippy-backdrop", fr = "tippy-arrow", pr = "tippy-svg-arrow", he = {
  passive: !0,
  capture: !0
}, dr = function() {
  return document.body;
};
function Bs(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function Ot(e, t, n) {
  if (Array.isArray(e)) {
    var r = e[t];
    return r ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function Tt(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function vr(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function wn(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      e(r);
    }, t);
  };
}
function Vs(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(r) {
    delete n[r];
  }), n;
}
function Fs(e) {
  return e.split(/\s+/).filter(Boolean);
}
function $e(e) {
  return [].concat(e);
}
function xn(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Us(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function Ws(e) {
  return e.split("-")[0];
}
function gt(e) {
  return [].slice.call(e);
}
function On(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function Ye() {
  return document.createElement("div");
}
function Ke(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Tt(e, t);
  });
}
function Hs(e) {
  return Tt(e, "NodeList");
}
function qs(e) {
  return Tt(e, "MouseEvent");
}
function Gs(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function Ys(e) {
  return Ke(e) ? [e] : Hs(e) ? gt(e) : Array.isArray(e) ? e : gt(document.querySelectorAll(e));
}
function Et(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function En(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function zs(e) {
  var t, n = $e(e), r = n[0];
  return r != null && (t = r.ownerDocument) != null && t.body ? r.ownerDocument : document;
}
function Xs(e, t) {
  var n = t.clientX, r = t.clientY;
  return e.every(function(i) {
    var a = i.popperRect, s = i.popperState, l = i.props, c = l.interactiveBorder, p = Ws(s.placement), f = s.modifiersData.offset;
    if (!f)
      return !0;
    var y = p === "bottom" ? f.top.y : 0, b = p === "top" ? f.bottom.y : 0, g = p === "right" ? f.left.x : 0, w = p === "left" ? f.right.x : 0, m = a.top - r + y > c, x = r - a.bottom - b > c, A = a.left - n + g > c, k = n - a.right - w > c;
    return m || x || A || k;
  });
}
function At(e, t, n) {
  var r = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(i) {
    e[r](i, n);
  });
}
function An(e, t) {
  for (var n = t; n; ) {
    var r;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var re = {
  isTouch: !1
}, kn = 0;
function Ts() {
  re.isTouch || (re.isTouch = !0, window.performance && document.addEventListener("mousemove", gr));
}
function gr() {
  var e = performance.now();
  e - kn < 20 && (re.isTouch = !1, document.removeEventListener("mousemove", gr)), kn = e;
}
function Ks() {
  var e = document.activeElement;
  if (Gs(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function Js() {
  document.addEventListener("touchstart", Ts, he), window.addEventListener("blur", Ks);
}
var Zs = typeof window < "u" && typeof document < "u", Qs = Zs ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function De(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function Sn(e) {
  var t = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return e.replace(t, " ").replace(n, "").trim();
}
function Ns(e) {
  return Sn(`
  %ctippy.js

  %c` + Sn(e) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function br(e) {
  return [
    Ns(e),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Je;
process.env.NODE_ENV !== "production" && Ps();
function Ps() {
  Je = /* @__PURE__ */ new Set();
}
function le(e, t) {
  if (e && !Je.has(t)) {
    var n;
    Je.add(t), (n = console).warn.apply(n, br(t));
  }
}
function Mt(e, t) {
  if (e && !Je.has(t)) {
    var n;
    Je.add(t), (n = console).error.apply(n, br(t));
  }
}
function Is(e) {
  var t = !e, n = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  Mt(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Mt(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var mr = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, ec = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, T = Object.assign({
  appendTo: dr,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, mr, ec), tc = Object.keys(T), nc = function(t) {
  process.env.NODE_ENV !== "production" && hr(t, []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    T[r] = t[r];
  });
};
function yr(e) {
  var t = e.plugins || [], n = t.reduce(function(r, i) {
    var a = i.name, s = i.defaultValue;
    if (a) {
      var l;
      r[a] = e[a] !== void 0 ? e[a] : (l = T[a]) != null ? l : s;
    }
    return r;
  }, {});
  return Object.assign({}, e, n);
}
function rc(e, t) {
  var n = t ? Object.keys(yr(Object.assign({}, T, {
    plugins: t
  }))) : tc, r = n.reduce(function(i, a) {
    var s = (e.getAttribute("data-tippy-" + a) || "").trim();
    if (!s)
      return i;
    if (a === "content")
      i[a] = s;
    else
      try {
        i[a] = JSON.parse(s);
      } catch {
        i[a] = s;
      }
    return i;
  }, {});
  return r;
}
function Dn(e, t) {
  var n = Object.assign({}, t, {
    content: vr(t.content, [e])
  }, t.ignoreAttributes ? {} : rc(e, t.plugins));
  return n.aria = Object.assign({}, T.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function hr(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    var i = Vs(T, Object.keys(mr)), a = !Bs(i, r);
    a && (a = t.filter(function(s) {
      return s.name === r;
    }).length === 0), le(a, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var ic = function() {
  return "innerHTML";
};
function Bt(e, t) {
  e[ic()] = t;
}
function $n(e) {
  var t = Ye();
  return e === !0 ? t.className = fr : (t.className = pr, Ke(e) ? t.appendChild(e) : Bt(t, e)), t;
}
function jn(e, t) {
  Ke(t.content) ? (Bt(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Bt(e, t.content) : e.textContent = t.content);
}
function Vt(e) {
  var t = e.firstElementChild, n = gt(t.children);
  return {
    box: t,
    content: n.find(function(r) {
      return r.classList.contains(ur);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(fr) || r.classList.contains(pr);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(Ms);
    })
  };
}
function wr(e) {
  var t = Ye(), n = Ye();
  n.className = _s, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Ye();
  r.className = ur, r.setAttribute("data-state", "hidden"), jn(r, e.props), t.appendChild(n), n.appendChild(r), i(e.props, e.props);
  function i(a, s) {
    var l = Vt(t), c = l.box, p = l.content, f = l.arrow;
    s.theme ? c.setAttribute("data-theme", s.theme) : c.removeAttribute("data-theme"), typeof s.animation == "string" ? c.setAttribute("data-animation", s.animation) : c.removeAttribute("data-animation"), s.inertia ? c.setAttribute("data-inertia", "") : c.removeAttribute("data-inertia"), c.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? c.setAttribute("role", s.role) : c.removeAttribute("role"), (a.content !== s.content || a.allowHTML !== s.allowHTML) && jn(p, e.props), s.arrow ? f ? a.arrow !== s.arrow && (c.removeChild(f), c.appendChild($n(s.arrow))) : c.appendChild($n(s.arrow)) : f && c.removeChild(f);
  }
  return {
    popper: t,
    onUpdate: i
  };
}
wr.$$tippy = !0;
var oc = 1, ft = [], kt = [];
function ac(e, t) {
  var n = Dn(e, Object.assign({}, T, yr(On(t)))), r, i, a, s = !1, l = !1, c = !1, p = !1, f, y, b, g = [], w = wn(Ie, n.interactiveDebounce), m, x = oc++, A = null, k = Us(n.plugins), j = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, o = {
    // properties
    id: x,
    reference: e,
    popper: Ye(),
    popperInstance: A,
    props: n,
    state: j,
    plugins: k,
    // methods
    clearDelayTimeouts: it,
    setProps: ot,
    setContent: at,
    show: Sr,
    hide: Dr,
    hideWithInteractivity: $r,
    enable: Fe,
    disable: rt,
    unmount: jr,
    destroy: Cr
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && Mt(!0, "render() function has not been supplied."), o;
  var O = n.render(o), d = O.popper, C = O.onUpdate;
  d.setAttribute("data-tippy-root", ""), d.id = "tippy-" + o.id, o.popper = d, e._tippy = o, d._tippy = o;
  var L = k.map(function(u) {
    return u.fn(o);
  }), D = e.hasAttribute("aria-expanded");
  return Ae(), q(), W(), U("onCreate", [o]), n.showOnCreate && Ve(), d.addEventListener("mouseenter", function() {
    o.props.interactive && o.state.isVisible && o.clearDelayTimeouts();
  }), d.addEventListener("mouseleave", function() {
    o.props.interactive && o.props.trigger.indexOf("mouseenter") >= 0 && B().addEventListener("mousemove", w);
  }), o;
  function R() {
    var u = o.props.touch;
    return Array.isArray(u) ? u : [u, 0];
  }
  function S() {
    return R()[0] === "hold";
  }
  function _() {
    var u;
    return !!((u = o.props.render) != null && u.$$tippy);
  }
  function V() {
    return m || e;
  }
  function B() {
    var u = V().parentNode;
    return u ? zs(u) : document;
  }
  function E() {
    return Vt(d);
  }
  function H(u) {
    return o.state.isMounted && !o.state.isVisible || re.isTouch || f && f.type === "focus" ? 0 : Ot(o.props.delay, u ? 0 : 1, T.delay);
  }
  function W(u) {
    u === void 0 && (u = !1), d.style.pointerEvents = o.props.interactive && !u ? "" : "none", d.style.zIndex = "" + o.props.zIndex;
  }
  function U(u, v, h) {
    if (h === void 0 && (h = !0), L.forEach(function($) {
      $[u] && $[u].apply($, v);
    }), h) {
      var M;
      (M = o.props)[u].apply(M, v);
    }
  }
  function G() {
    var u = o.props.aria;
    if (u.content) {
      var v = "aria-" + u.content, h = d.id, M = $e(o.props.triggerTarget || e);
      M.forEach(function($) {
        var Y = $.getAttribute(v);
        if (o.state.isVisible)
          $.setAttribute(v, Y ? Y + " " + h : h);
        else {
          var Z = Y && Y.replace(h, "").trim();
          Z ? $.setAttribute(v, Z) : $.removeAttribute(v);
        }
      });
    }
  }
  function q() {
    if (!(D || !o.props.aria.expanded)) {
      var u = $e(o.props.triggerTarget || e);
      u.forEach(function(v) {
        o.props.interactive ? v.setAttribute("aria-expanded", o.state.isVisible && v === V() ? "true" : "false") : v.removeAttribute("aria-expanded");
      });
    }
  }
  function ve() {
    B().removeEventListener("mousemove", w), ft = ft.filter(function(u) {
      return u !== w;
    });
  }
  function ne(u) {
    if (!(re.isTouch && (c || u.type === "mousedown"))) {
      var v = u.composedPath && u.composedPath()[0] || u.target;
      if (!(o.props.interactive && An(d, v))) {
        if ($e(o.props.triggerTarget || e).some(function(h) {
          return An(h, v);
        })) {
          if (re.isTouch || o.state.isVisible && o.props.trigger.indexOf("click") >= 0)
            return;
        } else
          U("onClickOutside", [o, u]);
        o.props.hideOnClick === !0 && (o.clearDelayTimeouts(), o.hide(), l = !0, setTimeout(function() {
          l = !1;
        }), o.state.isMounted || ae());
      }
    }
  }
  function ge() {
    c = !0;
  }
  function oe() {
    c = !1;
  }
  function I() {
    var u = B();
    u.addEventListener("mousedown", ne, !0), u.addEventListener("touchend", ne, he), u.addEventListener("touchstart", oe, he), u.addEventListener("touchmove", ge, he);
  }
  function ae() {
    var u = B();
    u.removeEventListener("mousedown", ne, !0), u.removeEventListener("touchend", ne, he), u.removeEventListener("touchstart", oe, he), u.removeEventListener("touchmove", ge, he);
  }
  function Oe(u, v) {
    Ee(u, function() {
      !o.state.isVisible && d.parentNode && d.parentNode.contains(d) && v();
    });
  }
  function se(u, v) {
    Ee(u, v);
  }
  function Ee(u, v) {
    var h = E().box;
    function M($) {
      $.target === h && (At(h, "remove", M), v());
    }
    if (u === 0)
      return v();
    At(h, "remove", y), At(h, "add", M), y = M;
  }
  function ue(u, v, h) {
    h === void 0 && (h = !1);
    var M = $e(o.props.triggerTarget || e);
    M.forEach(function($) {
      $.addEventListener(u, v, h), g.push({
        node: $,
        eventType: u,
        handler: v,
        options: h
      });
    });
  }
  function Ae() {
    S() && (ue("touchstart", _e, {
      passive: !0
    }), ue("touchend", et, {
      passive: !0
    })), Fs(o.props.trigger).forEach(function(u) {
      if (u !== "manual")
        switch (ue(u, _e), u) {
          case "mouseenter":
            ue("mouseleave", et);
            break;
          case "focus":
            ue(Qs ? "focusout" : "blur", Me);
            break;
          case "focusin":
            ue("focusout", Me);
            break;
        }
    });
  }
  function Pe() {
    g.forEach(function(u) {
      var v = u.node, h = u.eventType, M = u.handler, $ = u.options;
      v.removeEventListener(h, M, $);
    }), g = [];
  }
  function _e(u) {
    var v, h = !1;
    if (!(!o.state.isEnabled || Be(u) || l)) {
      var M = ((v = f) == null ? void 0 : v.type) === "focus";
      f = u, m = u.currentTarget, q(), !o.state.isVisible && qs(u) && ft.forEach(function($) {
        return $(u);
      }), u.type === "click" && (o.props.trigger.indexOf("mouseenter") < 0 || s) && o.props.hideOnClick !== !1 && o.state.isVisible ? h = !0 : Ve(u), u.type === "click" && (s = !h), h && !M && be(u);
    }
  }
  function Ie(u) {
    var v = u.target, h = V().contains(v) || d.contains(v);
    if (!(u.type === "mousemove" && h)) {
      var M = fe().concat(d).map(function($) {
        var Y, Z = $._tippy, ke = (Y = Z.popperInstance) == null ? void 0 : Y.state;
        return ke ? {
          popperRect: $.getBoundingClientRect(),
          popperState: ke,
          props: n
        } : null;
      }).filter(Boolean);
      Xs(M, u) && (ve(), be(u));
    }
  }
  function et(u) {
    var v = Be(u) || o.props.trigger.indexOf("click") >= 0 && s;
    if (!v) {
      if (o.props.interactive) {
        o.hideWithInteractivity(u);
        return;
      }
      be(u);
    }
  }
  function Me(u) {
    o.props.trigger.indexOf("focusin") < 0 && u.target !== V() || o.props.interactive && u.relatedTarget && d.contains(u.relatedTarget) || be(u);
  }
  function Be(u) {
    return re.isTouch ? S() !== u.type.indexOf("touch") >= 0 : !1;
  }
  function tt() {
    nt();
    var u = o.props, v = u.popperOptions, h = u.placement, M = u.offset, $ = u.getReferenceClientRect, Y = u.moveTransition, Z = _() ? Vt(d).arrow : null, ke = $ ? {
      getBoundingClientRect: $,
      contextElement: $.contextElement || V()
    } : e, Kt = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(st) {
        var Se = st.state;
        if (_()) {
          var Rr = E(), ht = Rr.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(ct) {
            ct === "placement" ? ht.setAttribute("data-placement", Se.placement) : Se.attributes.popper["data-popper-" + ct] ? ht.setAttribute("data-" + ct, "") : ht.removeAttribute("data-" + ct);
          }), Se.attributes.popper = {};
        }
      }
    }, me = [{
      name: "offset",
      options: {
        offset: M
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Y
      }
    }, Kt];
    _() && Z && me.push({
      name: "arrow",
      options: {
        element: Z,
        padding: 3
      }
    }), me.push.apply(me, (v == null ? void 0 : v.modifiers) || []), o.popperInstance = Ls(ke, d, Object.assign({}, v, {
      placement: h,
      onFirstUpdate: b,
      modifiers: me
    }));
  }
  function nt() {
    o.popperInstance && (o.popperInstance.destroy(), o.popperInstance = null);
  }
  function ce() {
    var u = o.props.appendTo, v, h = V();
    o.props.interactive && u === dr || u === "parent" ? v = h.parentNode : v = vr(u, [h]), v.contains(d) || v.appendChild(d), o.state.isMounted = !0, tt(), process.env.NODE_ENV !== "production" && le(o.props.interactive && u === T.appendTo && h.nextElementSibling !== d, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function fe() {
    return gt(d.querySelectorAll("[data-tippy-root]"));
  }
  function Ve(u) {
    o.clearDelayTimeouts(), u && U("onTrigger", [o, u]), I();
    var v = H(!0), h = R(), M = h[0], $ = h[1];
    re.isTouch && M === "hold" && $ && (v = $), v ? r = setTimeout(function() {
      o.show();
    }, v) : o.show();
  }
  function be(u) {
    if (o.clearDelayTimeouts(), U("onUntrigger", [o, u]), !o.state.isVisible) {
      ae();
      return;
    }
    if (!(o.props.trigger.indexOf("mouseenter") >= 0 && o.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(u.type) >= 0 && s)) {
      var v = H(!1);
      v ? i = setTimeout(function() {
        o.state.isVisible && o.hide();
      }, v) : a = requestAnimationFrame(function() {
        o.hide();
      });
    }
  }
  function Fe() {
    o.state.isEnabled = !0;
  }
  function rt() {
    o.hide(), o.state.isEnabled = !1;
  }
  function it() {
    clearTimeout(r), clearTimeout(i), cancelAnimationFrame(a);
  }
  function ot(u) {
    if (process.env.NODE_ENV !== "production" && le(o.state.isDestroyed, De("setProps")), !o.state.isDestroyed) {
      U("onBeforeUpdate", [o, u]), Pe();
      var v = o.props, h = Dn(e, Object.assign({}, v, On(u), {
        ignoreAttributes: !0
      }));
      o.props = h, Ae(), v.interactiveDebounce !== h.interactiveDebounce && (ve(), w = wn(Ie, h.interactiveDebounce)), v.triggerTarget && !h.triggerTarget ? $e(v.triggerTarget).forEach(function(M) {
        M.removeAttribute("aria-expanded");
      }) : h.triggerTarget && e.removeAttribute("aria-expanded"), q(), W(), C && C(v, h), o.popperInstance && (tt(), fe().forEach(function(M) {
        requestAnimationFrame(M._tippy.popperInstance.forceUpdate);
      })), U("onAfterUpdate", [o, u]);
    }
  }
  function at(u) {
    o.setProps({
      content: u
    });
  }
  function Sr() {
    process.env.NODE_ENV !== "production" && le(o.state.isDestroyed, De("show"));
    var u = o.state.isVisible, v = o.state.isDestroyed, h = !o.state.isEnabled, M = re.isTouch && !o.props.touch, $ = Ot(o.props.duration, 0, T.duration);
    if (!(u || v || h || M) && !V().hasAttribute("disabled") && (U("onShow", [o], !1), o.props.onShow(o) !== !1)) {
      if (o.state.isVisible = !0, _() && (d.style.visibility = "visible"), W(), I(), o.state.isMounted || (d.style.transition = "none"), _()) {
        var Y = E(), Z = Y.box, ke = Y.content;
        Et([Z, ke], 0);
      }
      b = function() {
        var me;
        if (!(!o.state.isVisible || p)) {
          if (p = !0, d.offsetHeight, d.style.transition = o.props.moveTransition, _() && o.props.animation) {
            var yt = E(), st = yt.box, Se = yt.content;
            Et([st, Se], $), En([st, Se], "visible");
          }
          G(), q(), xn(kt, o), (me = o.popperInstance) == null || me.forceUpdate(), U("onMount", [o]), o.props.animation && _() && se($, function() {
            o.state.isShown = !0, U("onShown", [o]);
          });
        }
      }, ce();
    }
  }
  function Dr() {
    process.env.NODE_ENV !== "production" && le(o.state.isDestroyed, De("hide"));
    var u = !o.state.isVisible, v = o.state.isDestroyed, h = !o.state.isEnabled, M = Ot(o.props.duration, 1, T.duration);
    if (!(u || v || h) && (U("onHide", [o], !1), o.props.onHide(o) !== !1)) {
      if (o.state.isVisible = !1, o.state.isShown = !1, p = !1, s = !1, _() && (d.style.visibility = "hidden"), ve(), ae(), W(!0), _()) {
        var $ = E(), Y = $.box, Z = $.content;
        o.props.animation && (Et([Y, Z], M), En([Y, Z], "hidden"));
      }
      G(), q(), o.props.animation ? _() && Oe(M, o.unmount) : o.unmount();
    }
  }
  function $r(u) {
    process.env.NODE_ENV !== "production" && le(o.state.isDestroyed, De("hideWithInteractivity")), B().addEventListener("mousemove", w), xn(ft, w), w(u);
  }
  function jr() {
    process.env.NODE_ENV !== "production" && le(o.state.isDestroyed, De("unmount")), o.state.isVisible && o.hide(), o.state.isMounted && (nt(), fe().forEach(function(u) {
      u._tippy.unmount();
    }), d.parentNode && d.parentNode.removeChild(d), kt = kt.filter(function(u) {
      return u !== o;
    }), o.state.isMounted = !1, U("onHidden", [o]));
  }
  function Cr() {
    process.env.NODE_ENV !== "production" && le(o.state.isDestroyed, De("destroy")), !o.state.isDestroyed && (o.clearDelayTimeouts(), o.unmount(), Pe(), delete e._tippy, o.state.isDestroyed = !0, U("onDestroy", [o]));
  }
}
function Ne(e, t) {
  t === void 0 && (t = {});
  var n = T.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (Is(e), hr(t, n)), Js();
  var r = Object.assign({}, t, {
    plugins: n
  }), i = Ys(e);
  if (process.env.NODE_ENV !== "production") {
    var a = Ke(r.content), s = i.length > 1;
    le(a && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var l = i.reduce(function(c, p) {
    var f = p && ac(p, r);
    return f && c.push(f), c;
  }, []);
  return Ke(e) ? l[0] : l;
}
Ne.defaultProps = T;
Ne.setDefaultProps = nc;
Ne.currentInput = re;
Object.assign({}, nr, {
  effect: function(t) {
    var n = t.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
Ne.setDefaultProps({
  render: wr
});
function xr(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
var Or = typeof window < "u" && typeof document < "u";
function Ft(e, t) {
  e && (typeof e == "function" && e(t), {}.hasOwnProperty.call(e, "current") && (e.current = t));
}
function Cn() {
  return Or && document.createElement("div");
}
function sc(e) {
  var t = {
    "data-placement": e.placement
  };
  return e.referenceHidden && (t["data-reference-hidden"] = ""), e.escaped && (t["data-escaped"] = ""), t;
}
function Er(e, t) {
  if (e === t)
    return !0;
  if (typeof e == "object" && e != null && typeof t == "object" && t != null) {
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (var n in e)
      if (t.hasOwnProperty(n)) {
        if (!Er(e[n], t[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function cc(e) {
  var t = [];
  return e.forEach(function(n) {
    t.find(function(r) {
      return Er(n, r);
    }) || t.push(n);
  }), t;
}
function lc(e, t) {
  var n, r;
  return Object.assign({}, t, {
    popperOptions: Object.assign({}, e.popperOptions, t.popperOptions, {
      modifiers: cc([].concat(((n = e.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = t.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var St = Or ? Mr : Fn;
function uc(e) {
  var t = Br();
  return t.current || (t.current = typeof e == "function" ? e() : e), t.current;
}
function Rn(e, t, n) {
  n.split(/\s+/).forEach(function(r) {
    r && e.classList[t](r);
  });
}
var fc = {
  name: "className",
  defaultValue: "",
  fn: function(t) {
    var n = t.popper.firstElementChild, r = function() {
      var l;
      return !!((l = t.props.render) != null && l.$$tippy);
    };
    function i() {
      if (t.props.className && !r()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      Rn(n, "add", t.props.className);
    }
    function a() {
      r() && Rn(n, "remove", t.props.className);
    }
    return {
      onCreate: i,
      onBeforeUpdate: a,
      onAfterUpdate: i
    };
  }
};
function pc(e) {
  function t(n) {
    var r = n.children, i = n.content, a = n.visible, s = n.singleton, l = n.render, c = n.reference, p = n.disabled, f = p === void 0 ? !1 : p, y = n.ignoreAttributes, b = y === void 0 ? !0 : y;
    n.__source, n.__self;
    var g = xr(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), w = a !== void 0, m = s !== void 0, x = He(!1), A = x[0], k = x[1], j = He({}), o = j[0], O = j[1], d = He(), C = d[0], L = d[1], D = uc(function() {
      return {
        container: Cn(),
        renders: 1
      };
    }), R = Object.assign({
      ignoreAttributes: b
    }, g, {
      content: D.container
    });
    w && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(B) {
      R[B] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + B + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), R.trigger = "manual", R.hideOnClick = !1), m && (f = !0);
    var S = R, _ = R.plugins || [];
    l && (S = Object.assign({}, R, {
      plugins: m && s.data != null ? [].concat(_, [{
        fn: function() {
          return {
            onTrigger: function(H, W) {
              var U = s.data.children.find(function(G) {
                var q = G.instance;
                return q.reference === W.currentTarget;
              });
              H.state.$$activeSingletonInstance = U.instance, L(U.content);
            }
          };
        }
      }]) : _,
      render: function() {
        return {
          popper: D.container
        };
      }
    }));
    var V = [c].concat(r ? [r.type] : []);
    return St(function() {
      var B = c;
      c && c.hasOwnProperty("current") && (B = c.current);
      var E = e(B || D.ref || Cn(), Object.assign({}, S, {
        plugins: [fc].concat(R.plugins || [])
      }));
      return D.instance = E, f && E.disable(), a && E.show(), m && s.hook({
        instance: E,
        content: i,
        props: S,
        setSingletonContent: L
      }), k(!0), function() {
        E.destroy(), s == null || s.cleanup(E);
      };
    }, V), St(function() {
      var B;
      if (D.renders === 1) {
        D.renders++;
        return;
      }
      var E = D.instance;
      E.setProps(lc(E.props, S)), (B = E.popperInstance) == null || B.forceUpdate(), f ? E.disable() : E.enable(), w && (a ? E.show() : E.hide()), m && s.hook({
        instance: E,
        content: i,
        props: S,
        setSingletonContent: L
      });
    }), St(function() {
      var B;
      if (l) {
        var E = D.instance;
        E.setProps({
          popperOptions: Object.assign({}, E.props.popperOptions, {
            modifiers: [].concat((((B = E.props.popperOptions) == null ? void 0 : B.modifiers) || []).filter(function(H) {
              var W = H.name;
              return W !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(W) {
                var U, G = W.state, q = (U = G.modifiersData) == null ? void 0 : U.hide;
                (o.placement !== G.placement || o.referenceHidden !== (q == null ? void 0 : q.isReferenceHidden) || o.escaped !== (q == null ? void 0 : q.hasPopperEscaped)) && O({
                  placement: G.placement,
                  referenceHidden: q == null ? void 0 : q.isReferenceHidden,
                  escaped: q == null ? void 0 : q.hasPopperEscaped
                }), G.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [o.placement, o.referenceHidden, o.escaped].concat(V)), /* @__PURE__ */ $t.createElement($t.Fragment, null, r ? /* @__PURE__ */ Vn(r, {
      ref: function(E) {
        D.ref = E, Ft(r.ref, E);
      }
    }) : null, A && /* @__PURE__ */ Ur(l ? l(sc(o), C, D.instance) : i, D.container));
  }
  return t;
}
var dc = function(e, t) {
  return /* @__PURE__ */ _r(function(r, i) {
    var a = r.children, s = xr(r, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ $t.createElement(e, Object.assign({}, t, s), a ? /* @__PURE__ */ Vn(a, {
        ref: function(c) {
          Ft(i, c), Ft(a.ref, c);
        }
      }) : null)
    );
  });
}, vc = /* @__PURE__ */ dc(/* @__PURE__ */ pc(Ne));
const gc = vc, bc = {
  name: "hideOnPopperBlur",
  defaultValue: !0,
  fn({ props: e, popper: t, hide: n }) {
    return {
      onCreate() {
        t.addEventListener("focusout", ({ relatedTarget: r }) => {
          e.hideOnPopperBlur && r && !t.contains(r) && n();
        });
      }
    };
  }
}, mc = {
  name: "hideOnEsc",
  defaultValue: !0,
  fn({ hide: e, reference: t, props: n }) {
    function r(i) {
      n.hideOnEsc && i.key === "Escape" && (e(), t == null || t.focus());
    }
    return {
      onShow() {
        document.addEventListener("keydown", r);
      },
      onHide() {
        document.removeEventListener("keydown", r);
      }
    };
  }
}, Dt = {
  info: {
    iconName: "info-round",
    buttonClassName: `
      tw-text-gray-darkest
      hover:tw-text-black
      dark:tw-text-gray-lightest
      dark:hover:tw-text-white
    `,
    title: "More information"
  },
  warning: {
    iconName: "warning-triangle",
    buttonClassName: `
      tw-text-gold
      hover:tw-text-gold-darker
      dark:tw-text-gold-lighter
      dark:hover:tw-text-gold-lightest
    `,
    title: "Alert"
  },
  error: {
    iconName: "warning-round",
    buttonClassName: `
      tw-text-red-darker
      hover:tw-text-red-darkest
      dark:tw-text-red-lighter
      dark:hover:tw-text-red-lightest
    `,
    title: "Error"
  }
}, yc = (e) => Q(
  "!tw-bg-transparent",
  "tw-border-none",
  "tw-rounded-full",
  "tw-inline-flex",
  "tw-p-0",
  "tw-outline-0",
  "tw-relative",
  "tw-h-2",
  "tw-w-2",
  "tw-left-[-4px]",
  "tw-top-[2px]",
  "focus:tw-ring-2",
  "tw-cursor-help",
  e
), hc = ({
  floating: e,
  nowrap: t,
  className: n
}) => Q(
  "tw-text-white",
  "tw-leading-normal",
  "tw-bg-black",
  "tw-rounded-lg",
  "tw-py-[12px]",
  "tw-px-2",
  "tw-text-sm",
  e && "tw-translate-z-0 tw--translate-y-1/2 tw-translate-x-[calc(0-(theme(spacing.3)+theme(spacing.nano)))]",
  t && "tw-whitespace-nowrap",
  "code:tw-text-white",
  "code:tw-p-0",
  "code:tw-bg-transparent",
  "dark:tw-bg-gray-darker",
  "dark:tw-border",
  "dark:tw-border-gray-dark",
  n
), wc = ({
  floating: e = !1,
  nowrap: t = !1,
  outset: n,
  children: r,
  intent: i = "info",
  iconName: a = Dt[i].iconName,
  buttonClassName: s = Dt[i].buttonClassName,
  title: l = Dt[i].title,
  appendTo: c = "parent",
  description: p,
  maxWidth: f = 416,
  offset: y = [0, parseInt(ma, 10)],
  visible: b,
  className: g,
  onClickOutside: w,
  onClick: m,
  id: x,
  ...A
}) => {
  const k = typeof b < "u" ? { onClickOutside: w, visible: b } : {
    trigger: "click mouseenter focusin"
  };
  return /* @__PURE__ */ F(
    gc,
    {
      arrow: !1,
      className: typeof A.render > "u" ? hc({ floating: e, nowrap: t, className: g }) : void 0,
      content: p,
      offset: y,
      duration: 0,
      plugins: [mc, bc],
      interactive: !0,
      maxWidth: f,
      appendTo: c,
      popperOptions: {
        modifiers: [
          {
            name: "flip",
            options: {
              fallbackPlacements: ["top"]
            }
          }
        ]
      },
      ...k,
      ...A,
      children: r || /**
       * This wrapper:
       * 1. Uses `outset` to create some spacing around the tooltipped button
       * 2. Allows the buttons for floating tooltips to appear inline next to
       * other elements. Without this, the button's placement will break.
       */
      /* @__PURE__ */ F(
        "span",
        {
          className: Q(
            n,
            e && "tw-absolute tw-right-[-32px] tw-mt-[-32px]"
          ),
          children: /* @__PURE__ */ F(
            "button",
            {
              id: x,
              className: yc(s),
              type: "button",
              onClick: (j) => {
                j.preventDefault(), m == null || m();
              },
              children: /* @__PURE__ */ F(Cc, { title: l, name: a })
            }
          )
        }
      )
    }
  );
}, xc = (e) => {
  try {
    const t = process.env.NETLIFY_IMAGES_CDN_DOMAIN;
    return new URL(e).host === t;
  } catch {
    return !1;
  }
}, Oc = (e) => {
  const t = e == null ? void 0 : e.avatar, n = t == null ? void 0 : t.href, r = e == null ? void 0 : e.avatar_url, i = e == null ? void 0 : e.user_metadata;
  return n || t || r || (i == null ? void 0 : i.avatar);
}, Ec = "https://secure.gravatar.com/avatar", Ac = {
  xs: 16,
  sm: 24,
  md: 40,
  lg: 100,
  xl: 128
};
function kc(e, t, n = 2) {
  const r = Math.round(t * n);
  return e.startsWith(Ec) ? `${e.split("?")[0]}?s=${r}&d=404` : e.match(/github/i) ? `${e.split("?")[0]}?s=${r}` : e.match(/gitlab/i) ? `${e.split("?")[0]}?size=${r}` : e;
}
const Ln = ({ children: e, hoverTooltip: t }) => t ? /* @__PURE__ */ F(
  wc,
  {
    description: t,
    trigger: "mouseenter",
    placement: "bottom",
    className: "!tw-p-1 !tw-py-[4px]",
    children: e
  }
) : e;
function _n({
  user: e,
  size: t,
  alt: n,
  altText: r,
  src: i,
  dropdown: a = !1,
  className: s = "",
  title: l = "",
  placeholderText: c,
  placeholderBackgroundColors: p,
  hoverTooltip: f
}) {
  var d;
  const [y, b] = He(!1), [g, w] = He(!1);
  i = i || Oc(e), Fn(() => {
    b(!1), w(!1);
  }, [i]);
  const m = e && (e.full_name || ((d = e.user_metadata) == null ? void 0 : d.full_name) || e.email) || "Anonymous", x = Q(
    "tw-rounded-full",
    "tw-inline-block",
    "tw-overflow-hidden",
    "tw-self-center",
    "tw-object-cover",
    "tw-border tw-border-gray-lightest dark:tw-border-gray-dark",
    !t && !a && "tw-h-avatar-sm tw-w-avatar-sm tw-text-xl tw-leading-[theme('height.avatar-sm')]",
    t === "xs" && "tw-h-2 tw-w-2 tw-text-[7px] tw-leading-chill",
    t === "sm" && "tw-text-l tw-h-3 tw-w-3 tw-leading-3",
    t === "md" && "tw-h-4 tw-w-4 tw-text-xl tw-leading-4",
    t === "lg" && "tw-h-avatar-lg tw-w-avatar-lg tw-text-2xl tw-leading-chill md:tw-h-avatar-xl md:tw-w-avatar-xl md:tw-text-3xl md:tw-leading-normal",
    t === "xl" && "tw-h-avatar-lg tw-w-avatar-lg tw-text-2xl tw-leading-[theme('height.avatar-lg')] md:tw-h-avatar-xxl md:tw-w-avatar-xxl md:tw-text-3xl md:tw-leading-[theme('height.avatar-xxl')]",
    a && "tw-absolute tw-left-0 tw-top-0 tw-m-0 tw-h-avatar-md tw-w-avatar-md tw-text-xl tw-leading-[theme('height.avatar-md')]",
    s
  ), A = Q(
    "tw-font-semibold",
    "tw-text-center",
    "tw-text-white"
  ), k = t && Ac[t] || 32, j = r || `${m}'s avatar`;
  if (i && !y) {
    const C = i && xc(i), L = n ? j : "";
    return /* @__PURE__ */ F(Ln, { hoverTooltip: f, children: C ? /* @__PURE__ */ F(
      Aa,
      {
        className: x,
        url: i,
        width: k,
        height: k,
        alt: L,
        title: l,
        onError: () => b(!0),
        cover: !0,
        animated: `${i}`.endsWith(".gif")
      }
    ) : /* @__PURE__ */ F(
      "img",
      {
        className: Q(x, !g && "tw-opacity-0"),
        src: kc(i, k),
        width: k,
        height: k,
        alt: L,
        title: l,
        onError: () => b(!0),
        onLoad: () => w(!0),
        loading: "lazy"
      }
    ) });
  }
  const o = c || m && ta(m, "", 1)[0].toUpperCase(), O = p || ha(e == null ? void 0 : e.id);
  return /* @__PURE__ */ F(Ln, { hoverTooltip: f, children: /* @__PURE__ */ ze(
    "span",
    {
      className: Q(x, A),
      title: l,
      "aria-hidden": !n,
      style: {
        background: `linear-gradient(to bottom right, ${O.to}, ${O.from})`
      },
      children: [
        o,
        n && /* @__PURE__ */ F("span", { className: "tw-sr-only", children: j })
      ]
    }
  ) });
}
const Mn = "tw-flex tw-items-center [&:not(:last-of-type)]:-tw-mr-1", Sc = ({
  additionalUsers: e = [],
  additionalTextType: t = "useName",
  additionalUsersLabelSingular: n,
  additionalUsersLabelPlural: r
}) => {
  const i = e.length === 1 ? n : r;
  return /* @__PURE__ */ F("span", { className: "tw-flex tw-flex-col tw-items-center", children: t === "useName" ? /* @__PURE__ */ ze(Lr, { children: [
    e.map((a, s = 0) => /* @__PURE__ */ F("span", { children: a == null ? void 0 : a.full_name }, `additional-user-${s}`)),
    i
  ] }) : /* @__PURE__ */ ze("span", { children: [
    e.length,
    " ",
    i
  ] }) });
};
function Bc({
  users: e,
  size: t,
  maxNumber: n,
  includeHoverTooltips: r = !1,
  additionalTextType: i = "useName",
  userLabel: a,
  additionalUsersLabelSingular: s,
  additionalUsersLabelPlural: l
}) {
  const c = n ? e.slice(0, n) : e, p = n ? e.length - n : 0, f = p > 0, y = `+${p}`;
  return !e || e.length === 0 ? null : /* @__PURE__ */ ze("ul", { className: "tw-flex tw-flex-row", children: [
    c.map((b) => {
      const w = `${(b == null ? void 0 : b.full_name) || (b == null ? void 0 : b.email)}${a ? ` ${a}` : ""}`;
      return /* @__PURE__ */ F("li", { className: Mn, children: /* @__PURE__ */ F(
        _n,
        {
          alt: !0,
          user: b,
          size: t,
          className: "tw-border-white dark:tw-border-black",
          hoverTooltip: r ? w : void 0
        }
      ) }, b == null ? void 0 : b.id);
    }),
    f && /* @__PURE__ */ F("li", { className: Mn, children: /* @__PURE__ */ F(
      _n,
      {
        alt: !0,
        altText: y,
        placeholderText: y,
        size: t,
        className: Q(
          "!tw-border-white tw-bg-gray-light tw-pr-[2px] !tw-font-regular !tw-text-gray-darkest dark:!tw-border-black dark:!tw-text-gray-lightest",
          {
            "!tw-text-[10px]": t === "sm" || !t
          }
        ),
        title: r ? void 0 : y,
        placeholderBackgroundColors: ya,
        hoverTooltip: r ? /* @__PURE__ */ F(
          Sc,
          {
            additionalUsers: e.slice(-p),
            additionalTextType: i,
            additionalUsersLabelPlural: l,
            additionalUsersLabelSingular: s
          }
        ) : void 0
      }
    ) }, "additional-users")
  ] });
}
function Vc(e) {
  return Number(e.replace("rem", "")) * 16;
}
const Bn = (e) => typeof e == "string" ? e : e ? `${e / 16}rem` : "1rem", Ar = Vr(
  void 0
), Fc = ({ children: e, importSvg: t }) => /* @__PURE__ */ F(Ar.Provider, { value: t, children: e }), Dc = () => {
  const e = Fr(Ar);
  if (!e)
    throw new Error("useSvg must be used within a SvgProvider");
  return e;
};
var kr = /* @__PURE__ */ ((e) => (e["agility-content"] = "icons/icon-agility-colored", e.ai = "icons/icon-ai", e.alphabet = "icons/icon-alphabet", e.announcement = "icons/icon-announcement", e.angular = "icons/icon-angular", e["angular-colored"] = "icons/icon-angular-colored", e["ask-netlify"] = "icons/icon-ask-netlify", e["ask-netlify-colored"] = "icons/icon-ask-netlify-colored", e.astro = "icons/icon-astro", e.alchemy = "icons/icon-alchemy", e["alchemy-colored"] = "icons/icon-alchemy-colored", e["azure-devops"] = "icons/icon-azure-devops", e["azure-devops-colored"] = "icons/icon-azure-devops-colored", e["background-functions"] = "icons/icon-background-functions", e["big-notification"] = "icons/icon-big-notification", e.bitbucket = "icons/icon-bitbucket", e["bitbucket-colored"] = "icons/icon-bitbucket-colored", e.block = "icons/icon-block", e.box = "icons/icon-box", e.building = "icons/icon-building", e.bulb = "icons/icon-bulb", e.briefcase = "icons/icon-briefcase", e.calendar = "icons/icon-calendar", e["caret-down"] = "icons/icon-caret-down", e.chat = "icons/icon-chat", e.clock = "icons/icon-clock", e.comment = "icons/icon-comment", e.commit = "icons/icon-commit", e.config = "icons/icon-config", e.connect = "icons/icon-connect", e.contentful = "icons/icon-contentful", e["contentful-colored"] = "icons/icon-contentful-colored", e.contentstack = "icons/icon-contentstack", e["contentstack-colored"] = "icons/icon-contentstack-colored", e["datocms-colored"] = "icons/icon-datocms-colored", e["deploy-diagnostics"] = "icons/icon-deploy-diagnostics", e["deploy-diagnostics-colored"] = "icons/icon-deploy-diagnostics-colored", e.download = "icons/icon-download", e.drupal = "icons/icon-drupal", e["drupal-colored"] = "icons/icon-drupal-colored", e.eleventy = "icons/eleventy", e.edit = "icons/icon-edit", e.email = "icons/icon-email", e.entry = "icons/icon-entry", e["eye-closed"] = "icons/icon-eye-closed", e["eye-open"] = "icons/icon-eye-open", e.gatsby = "icons/icon-gatsby", e.gear = "icons/icon-gear", e.gift = "icons/icon-gift", e["git-branch"] = "icons/icon-git-branch", e["git-branch-new"] = "icons/icon-git-branch-new", e["git-merge"] = "icons/icon-git-merge", e.github = "icons/icon-github", e["github-colored"] = "icons/icon-github-colored", e.gitlab = "icons/icon-gitlab", e["gitlab-colored"] = "icons/icon-gitlab-colored", e["google-colored"] = "icons/icon-google-colored", e["graduation-cap"] = "icons/icon-graduation-cap", e["graph-play"] = "icons/icon-graph-play", e.handshake = "icons/icon-handshake", e["high-perf-ADN"] = "icons/icon-high-perf-ADN", e["high-perf-ADN-not-configured"] = "icons/icon-high-perf-ADN-not-configured", e["high-perf-builds"] = "icons/icon-high-perf-builds", e.hugo = "icons/icon-hugo", e["info-round"] = "icons/icon-info-round", e.labs = "icons/icon-labs", e.laptop = "icons/icon-laptop", e.link = "icons/icon-link", e.menu = "icons/icon-menu", e.grid = "icons/icon-grid", e.network = "icons/icon-network", e.new = "icons/icon-new", e.nextjs = "icons/icon-nextjs", e["nextjs-colored"] = "icons/icon-nextjs-colored", e.nuxtjs = "icons/icon-nuxtjs", e["nuxtjs-colored"] = "icons/icon-nuxtjs-colored", e.pencil = "icons/icon-pencil", e["pencil-rounded"] = "icons/icon-pencil-rounded", e.prismic = "icons/icon-prismic", e.pushpin = "icons/icon-pushpin", e["question-mark"] = "icons/icon-question-mark", e.remix = "icons/icon-remix", e.retry = "icons/icon-retry", e.rocket = "icons/icon-rocket", e.sanity = "icons/icon-sanity", e["sanity-colored"] = "icons/icon-sanity-colored", e["sort-ascending"] = "icons/icon-sort-ascending", e["sort-descending"] = "icons/icon-sort-descending", e.storyblok = "icons/icon-storyblok", e["storyblok-colored"] = "icons/icon-storyblok-colored", e.strapi = "icons/icon-strapi", e["strapi-colored"] = "icons/icon-strapi-colored", e["screwdriver-wrench"] = "icons/icon-screwdriver-wrench", e.site = "icons/icon-site", e["split-test"] = "icons/icon-split-test", e.slack = "icons/icon-slack", e["slack-colored"] = "icons/icon-slack-colored", e.support = "icons/icon-support", e["thumbs-down"] = "icons/icon-thumbs-down", e["thumbs-up"] = "icons/icon-thumbs-up", e.pause = "icons/icon-pause", e.play = "icons/icon-play", e["plugin-round"] = "icons/icon-plugin-round", e["pull-request"] = "icons/icon-pull-request", e.shopify = "icons/icon-shopify", e["shopify-colored"] = "icons/icon-shopify-colored", e["speech-bubble"] = "icons/icon-speech-bubble", e.star = "icons/icon-star", e["star-outline"] = "icons/icon-star-outline", e["status-checkmark"] = "inline/icon-status-checkmark", e.stop = "icons/icon-stop", e["tag-edit"] = "icons/icon-tag-edit", e.token = "icons/icon-token", e.upload = "icons/icon-upload", e.user = "icons/icon-user", e.view = "icons/icon-view", e["warning-round"] = "icons/icon-warning-round", e["warning-triangle"] = "icons/icon-warning-triangle", e.webhook = "icons/icon-webhook", e.wordpress = "icons/icon-wordpress", e.back = "inline/icon-back", e.bottom = "inline/icon-bottom", e.checkmark = "inline/icon-checkmark", e.close = "inline/icon-close", e["copy-clipboard"] = "inline/icon-copy-clipboard", e.delete = "inline/icon-delete", e.file = "inline/icon-file", e["file-large"] = "inline/icon-file-large", e.folder = "inline/icon-folder", e["locked-tight"] = "inline/icon-locked-tight", e["locked-tight-circle"] = "inline/icon-locked-tight-circle", e.locked = "inline/icon-locked", e["magic-wand"] = "inline/icon-magic-wand", e.phone = "inline/icon-phone", e.plugin = "inline/icon-plugin", e.prohibition = "inline/icon-prohibition", e["right-circle"] = "inline/icon-right-circle", e.search = "inline/icon-search", e["slack-logo"] = "icon-slack-logo", e.solid = "icons/solid", e.sparkles = "icons/icon-sparkles", e["sparkly-slack-logo"] = "icon-slack-logo-sparkles", e.success = "inline/icon-success", e.top = "inline/icon-top", e.unlock = "icons/icon-unlock", e["up-circle"] = "inline/icon-up-circle", e["full-screen"] = "icons/icon-full-screen", e["exit-full-screen"] = "icons/icon-exit-full-screen", e["nav-blobs"] = "navigation/icon-nav-blobs", e["nav-blobs-active"] = "navigation/icon-nav-blobs-active", e["nav-caret"] = "navigation/icon-nav-caret", e["nav-create"] = "navigation/icon-nav-create", e["nav-site-overview"] = "navigation/icon-nav-site-overview", e["nav-site-overview-active"] = "navigation/icon-nav-site-overview-active", e["nav-site-configuration"] = "navigation/icon-nav-site-configuration", e["nav-site-configuration-active"] = "navigation/icon-nav-site-configuration-active", e["nav-deploys"] = "navigation/icon-nav-deploys", e["nav-deploys-active"] = "navigation/icon-nav-deploys-active", e["nav-functions"] = "navigation/icon-nav-functions", e["nav-functions-active"] = "navigation/icon-nav-functions-active", e["nav-edge-functions"] = "navigation/icon-nav-edge-functions", e["nav-edge-functions-active"] = "navigation/icon-nav-edge-functions-active", e["nav-integrations"] = "navigation/icon-nav-integrations", e["nav-integrations-active"] = "navigation/icon-nav-integrations-active", e["nav-analytics"] = "navigation/icon-nav-analytics", e["nav-analytics-active"] = "navigation/icon-nav-analytics-active", e["nav-forms"] = "navigation/icon-nav-forms", e["nav-forms-active"] = "navigation/icon-nav-forms-active", e["nav-split-testing"] = "navigation/icon-nav-split-testing", e["nav-split-testing-active"] = "navigation/icon-nav-split-testing-active", e["nav-large-media"] = "navigation/icon-nav-large-media", e["nav-large-media-active"] = "navigation/icon-nav-large-media-active", e["nav-logs"] = "navigation/icon-nav-logs", e["nav-logs-active"] = "navigation/icon-nav-logs-active", e["nav-team-overview"] = "navigation/icon-nav-team-overview", e["nav-team-overview-active"] = "navigation/icon-nav-team-overview-active", e["nav-sites"] = "navigation/icon-nav-sites", e["nav-sites-active"] = "navigation/icon-nav-sites-active", e["nav-builds"] = "navigation/icon-nav-builds", e["nav-builds-active"] = "navigation/icon-nav-builds-active", e["nav-connect"] = "navigation/icon-nav-connect", e["nav-connect-active"] = "navigation/icon-nav-connect-active", e["nav-domains"] = "navigation/icon-nav-domains", e["nav-domains-active"] = "navigation/icon-nav-domains-active", e["nav-domain-management"] = "navigation/icon-nav-domain-management", e["nav-domain-management-active"] = "navigation/icon-nav-domain-management-active", e["nav-members"] = "navigation/icon-nav-members", e["nav-members-active"] = "navigation/icon-nav-members-active", e["nav-audit-log"] = "navigation/icon-nav-audit-log", e["nav-audit-log-active"] = "navigation/icon-nav-audit-log-active", e["nav-billing"] = "navigation/icon-nav-billing", e["nav-billing-active"] = "navigation/icon-nav-billing-active", e["nav-team-settings"] = "navigation/icon-nav-team-settings", e["nav-team-settings-active"] = "navigation/icon-nav-team-settings-active", e["nav-labs"] = "navigation/icon-nav-labs", e["nav-labs-active"] = "navigation/icon-nav-labs-active", e["nav-news"] = "navigation/icon-nav-news", e["nav-news-active"] = "navigation/icon-nav-news-active", e["nav-news-unread"] = "navigation/icon-nav-news-unread", e["nav-shield"] = "navigation/icon-nav-shield", e["nav-shield-active"] = "navigation/icon-nav-shield-active", e["nav-support"] = "navigation/icon-nav-support", e["nav-support-active"] = "navigation/icon-nav-support-active", e["nav-command-palette"] = "navigation/icon-nav-command-palette", e["nav-toggle"] = "navigation/toggle/nav-toggle", e["nav-toggle-active"] = "navigation/toggle/nav-toggle-active", e))(kr || {});
function $c(e) {
  const t = wt.useRef(), [n, r] = wt.useState(!1), i = Dc();
  return wt.useEffect(() => {
    let a = !0;
    return r(!0), (async () => {
      try {
        t.current = (await i(kr[e])).ReactComponent;
      } catch (l) {
        console.error(l);
      } finally {
        a && r(!1);
      }
    })(), () => {
      a = !1;
    };
  }, [e, i]), [n, t.current || null];
}
function jc({
  className: e,
  name: t,
  width: n,
  height: r,
  ...i
}) {
  const [a, s] = $c(t), l = Bn(n), c = Bn(r);
  return a || !s ? /* @__PURE__ */ F(
    "span",
    {
      className: Q(e, "tw-inline-block"),
      style: {
        height: c,
        width: l
      }
    }
  ) : /* @__PURE__ */ F(
    s,
    {
      style: {
        "--icon-width": l,
        "--icon-height": c
      },
      "aria-hidden": !0,
      className: Q(
        "scalable-icon tw-inline !tw-fill-current tw-align-baseline",
        e
      ),
      height: void 0,
      width: void 0,
      ...i
    }
  );
}
function Cc(e) {
  return /* @__PURE__ */ F(jc, { "aria-hidden": void 0, role: "img", ...e });
}
function Uc({ children: e, wrap: t = !1, className: n = "" }) {
  return /* @__PURE__ */ F(
    "div",
    {
      className: Q(
        "tw-flex",
        "tw-gap-1",
        t ? "tw-flex-wrap" : "tw-flex-col",
        "snapshot",
        n
      ),
      children: e
    }
  );
}
export {
  Cc as AccessibleIcon,
  _n as Avatar,
  Bc as AvatarList,
  jc as DecorativeIcon,
  Aa as Picture,
  Uc as SnapshotContainer,
  Fc as SvgProvider,
  gc as Tippy,
  wc as Tooltip,
  Q as cn,
  In as generateImageUrl,
  Bn as getActualSizeForNumberValue,
  ha as getPlaceholderGradientColorsFromId,
  mc as hideOnEsc,
  bc as hideOnPopperBlur,
  xc as isAvatarUrlCustomUpload,
  Mc as metaInfoPlaceholderColorsDark,
  ya as metaInfoPlaceholderColorsLight,
  Vc as remToPxNumber,
  Dc as useImportSvg
};
//# sourceMappingURL=index.mjs.map
